import { Redirect, Route, useHistory } from 'react-router-dom';
import {
  IonApp,
  IonHeader,
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
  IonToolbar,
  IonTitle,
  IonPage,
  setupIonicReact,
  useIonToast,
  IonContent,
  IonItemGroup,
  useIonRouter,
  IonSpinner
} from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { people, calendar, triangle, cog, chatboxOutline, chatboxEllipsesOutline, ellipse, chatboxEllipses, giftOutline } from 'ionicons/icons';
import CalendarPage from './pages/CalendarPage';
import EventMonitor from './pages/EventEditor';
import Clients from './pages/Clients';
import Settings from './pages/Settings';
import Login from './pages/Login';
import ClientEditor from './pages/ClientEditor'
import { addErrorListener, getCurrentUser, getCurrentUserAuth, updateDevicePushId } from './firebase/firebase';



/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';
import { useContext, useEffect, useState } from 'react';
import { addOnAuthStateChangedListener, addPersistenceListener } from './firebase/firebase'
import ResourcesPage from './pages/ResourcesPage';
import SmsTemplatesPage from './pages/SmsTemplatesPage';
import ServicesPage from './pages/ServicesPage';
import UsersPage from './pages/UsersPage';
import SmsPage from './pages/SmsPage';
import SmsViewer from './pages/SmsViewer';
import ClientCommentEditor from './pages/ClientCommentEditor';
import ImageViewer from './pages/ImageViewer';
import DocumentTemplatesListPage from './pages/DocumentTemplatesListPage';
import DocumentTemplateEditor from './pages/DocumentTemplateEditor';
import { addSmsGroupListener } from './firebase/smsGroup';
import PushNotification from './pages/PushNotification';
import { addVersionListener } from './firebase/version';
import ImagePermissions from './pages/ImagePermissions';
import ReportsPage from './reports/ReportsPage';
import BirthdaysPage from './pages/BirthdaysPage';


setupIonicReact();




const LoginSystem: React.FC = () => {
  return (

    <IonReactRouter>
      <Route exact path="/app/login" component={Login} />
      <Route exact path="/app/">
        <Redirect to="/app/login" />
      </Route>
      <Route exact path="/">
        <Redirect to="/app/login" />
      </Route>
    </IonReactRouter>
  )
}




const App: React.FC = () => {
  const [newMessages, setNewMessages] = useState(false);
  const [newVersion, setNewVersion] = useState(false);
  const [presentToast] = useIonToast();

  useEffect(() => {
    addErrorListener((msg: string) => {
      presentToast({
        message: msg,
        duration: 3000,
        position: 'top'
      });
    });

    addSmsGroupListener((list: any) => {
      var newMessagesTmp = false;
      for (var i = 0; i < list.length; i++) {
        if (list[i].new) {
          newMessagesTmp = true;
          break;
        }
      }
      setNewMessages(newMessagesTmp);
    })

    addVersionListener((ifNew: boolean) => {
      setNewVersion(ifNew);
    })

  }, []);



  const [login, setLogin] = useState(false);
  const [user, setUser] = useState(getCurrentUser());


  const [dbPersistence, setDbPersistence] = useState(false);
  useEffect(() => {
    addOnAuthStateChangedListener((user: any) => {
      //console.log("addOnAuthStateChangedListener", user)
      setUser(user);
      if (user) {
        setLogin(true);
      } else {
        setLogin(false);
      }
      window.history.pushState({}, '', '/')
    })



    addPersistenceListener((persistence: boolean) => {
      setDbPersistence(persistence);
    })

  }, []);




  function isUserLogIn() {
    var auth = getCurrentUserAuth();
    return user !== undefined && user !== null && user.name !== undefined && auth?.emailVerified
  }

  var RoutingSystem = <IonReactRouter>

    <IonTabs>
      <IonRouterOutlet>
        <Route exact path="/app/calendar">
          <CalendarPage />
        </Route>
        <Route exact path="/app/clients">
          <Clients />
        </Route>
        <Route exact path="/app/birthdays">
          <BirthdaysPage />
        </Route>
        <Route exact path="/app/smses">
          <SmsPage />
        </Route>
        <Route exact path="/app/smses/:id">
          <SmsViewer />
        </Route>
        <Route exact path="/app/clients/:id">
          <ClientEditor />
        </Route>
        <Route exact path="/app/clients/:clientId/comment/:id">
          <ClientCommentEditor />
        </Route>
        <Route exact path="/app/clients/:clientId/comment/:id/:templateId">
          <ClientCommentEditor />
        </Route>
        <Route path="/app/imageviewer/:url">
          <ImageViewer />
        </Route>
        <Route path="/app/imagepermissions/:url">
          <ImagePermissions />
        </Route>
        <Route exact path="/app/settings">
          <Settings />
        </Route>
        <Route exact path="/app/reports">
          <ReportsPage />
        </Route>
        <Route exact path="/app/settings/resources">
          <ResourcesPage />
        </Route>
        <Route exact path="/app/settings/smstemplates">
          <SmsTemplatesPage />
        </Route>
        <Route exact path="/app/settings/documenttemplates">
          <DocumentTemplatesListPage />
        </Route>
        <Route exact path="/app/settings/documenttemplates/:id">
          <DocumentTemplateEditor />
        </Route>
        <Route exact path="/app/settings/services">
          <ServicesPage />
        </Route>
        <Route exact path="/app/settings/users">
          <UsersPage />
        </Route>

        <Route exact path="/app/">
          <Redirect to={isUserLogIn() ? "/app/calendar" : "/app/settings"} />
        </Route>
        <Route exact path="/">
          <Redirect to={isUserLogIn() ? "/app/calendar" : "/app/settings"} />
        </Route>
      </IonRouterOutlet>
      <IonTabBar slot="bottom">

        {isUserLogIn() ? <IonTabButton tab="calendar" href="/app/calendar">
          <IonIcon icon={calendar} />
        </IonTabButton> : ""}


        {isUserLogIn() && user.clientsPanel ? <IonTabButton tab="clients" href="/app/clients">
          <IonIcon icon={people} />
        </IonTabButton> : ""}

        {isUserLogIn() && (user.birthdaysPanel ?? user.clientsPanel) ? <IonTabButton tab="birthdays" href="/app/birthdays">
          <IonIcon icon={giftOutline} />
        </IonTabButton> : ""}


        {isUserLogIn() && user.sms && user.smsPanel ? <IonTabButton tab="smses" href="/app/smses">
          <IonIcon icon={newMessages ? chatboxEllipses : chatboxOutline} style={newMessages ? { color: "#ff0000" } : {}} />
        </IonTabButton> : ""}


        <IonTabButton tab="settings" href="/app/settings">
          <IonIcon icon={cog} style={newVersion ? { color: "#ff0000" } : {}} />
        </IonTabButton>
      </IonTabBar>
    </IonTabs>
  </IonReactRouter>;

  const ErrorPage =

    <IonPage >
      <IonHeader>
        <IonToolbar>
          <IonTitle>Błąd, aplikacja działa tylko w jednej zakładce!</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonItemGroup className="ion-padding">

        </IonItemGroup>
      </IonContent>
    </IonPage>;

  const LoadingPage =

    <IonPage >
      <IonHeader>
        <IonToolbar>
          <IonTitle>eGabinet</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent >
        <div style={{
          textAlign: "center",
          position: "absolute",
          left: "0",
          right: "0",
          top: "50%",
          transform: "translateY(-50%)"
        }}><IonSpinner></IonSpinner></div>

      </IonContent>
    </IonPage >;

  return (
    <IonApp>
      {dbPersistence === undefined ? LoadingPage : (dbPersistence ? (login ? RoutingSystem : <LoginSystem />) : ErrorPage)}
    </IonApp>
  )
};

export default App;
